module.exports = function(data) {

    this.count = data.length;

	 return data;
}



// WEBPACK FOOTER //
// ./~/vue-tables-2/lib/filters/set-count.js